module.exports = __webpack_public_path__ + "static/media/theme-thumbnail-image.270c1567.png";